import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { graphemeStrokesJsonColumn } from "@-/dev.improve.haniverse.database.schemas.static._lib.types.strokes";
import { index, integer } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

/**
 * Hanzi Writer stroke paths + medians for a grapheme, split out of `grapheme` into its own
 * 1:1 child table. The encoded stroke blob is large (~9MB across all rows — far bigger than
 * the rest of the `grapheme` row combined), so keeping it inline bloated every `grapheme`
 * leaf page and made id→glyph lookups (e.g. the decomposition-map join) read megabytes of
 * blob pages they never used — ~1s of native SQL time on device. With strokes in a separate
 * table, the `grapheme` row stays slim and only the few queries that actually render strokes
 * pay to read them (via the `strokeData` relation). Row is absent for graphemes with no
 * Hanzi Writer data (most decomposition-only components).
 */
export const graphemeStrokeDataTable = staticTable(
  "grapheme_stroke_data",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),

    /** Lossless compact-encoded stroke paths + medians; see `graphemeStrokesJsonColumn`. */
    strokeData: graphemeStrokesJsonColumn("stroke_data"),
  },
  (table) => [index("grapheme_stroke_data_grapheme_id_idx").on(table.graphemeId)],
);

export type GraphemeStrokeData = typeof graphemeStrokeDataTable.$inferSelect;
